module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_intro",
    attrs: {
      "epub:type": "introduction",
      "lang": "en-US",
      "role": "doc-introduction"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "role": "doc-pagebreak",
      "title": "5"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_c('span', [_vm._v("Introduction")])]), _c('div', {
    staticClass: "chapeau"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig-002_1",
      "role": "presentation",
      "src": "images/p1.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("T")]), _vm._v("he goal of Christian spiritual formation is to learn to experience the love of God and to learn to love as God loves. This is the simplest way I know to explain the spiritual journey. But what stands in the way of this journey is often unseen. And what is unseen has formidable strength to keep us in bondage to the things that prevent us from experiencing the love of God and from loving others in the way that God loves them.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The experience of the love of God is at the center of this book.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The love of God is the only thing that empowers real change in our lives.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("God is always present to us. And we are often not present to God. We are caught up in an array of distractions, pursuits, and thoughts that draw us away from the experience of God’s love.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("An important process in the spiritual formation journey—one that can help free us from the things that keep us bound—is getting a clear view of what prevents us from loving and being loved.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What is in the way? What prevents me from living into all that God is inviting me toward and saying yes to every invitation that God extends?")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "role": "doc-pagebreak",
      "title": "6"
    }
  }, [_vm._v("The answer to this question is different for each person. As Roberta Bondi articulates, “What prevents me from loving may be entirely different than what prevents you from loving.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-001",
      "id": "ap_ntf-001-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But getting a clear view of the things that disrupt our formation is becoming more difficult. We’ve lost some things along the way that the earliest generations of Christ-followers placed at the center of their way of life. The pursuit of "), _c('i', [_vm._v("humility")]), _vm._v(", for starters.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This book is a vision for engaging and reimagining the way of life that emerged in those early years. It is meant to allow the way of life early Christians pursued to address the current crises of discipleship. But this isn’t early-church nostalgia. It’s a vision for reimagining a "), _c('i', [_vm._v("way of life")]), _vm._v(" that has bolstered the formation of the Christian person in the way of love since the very beginning.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Our culture increasingly obscures our view of what keeps us in bondage. It is easy for us to grow accustomed to the very things that hold us back from a life devoted to being united to God. Our culture is perfectly designed to keep us distracted, disembodied, and removed from our own "), _c('i', [_vm._v("self.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We often live in invisible chains, which cause us to settle for a vision of our life that is so much less than the vision offered by God in Christ, who is nonetheless kind and loving and gentle and patient with us.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Some of these invisible chains are built for us by giant computers whose primary job is to learn how to keep our attention on the small black mirror we hold in our hands. The feed on that screen reflects our own desires.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We make other chains all on our own. The first step toward freedom is the willingness to embrace the reality that this is the state of things: there are things hidden from our view that get in the way of what we really want.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "role": "doc-pagebreak",
      "title": "7"
    }
  }, [_vm._v("We should not be afraid or ashamed of this fact. It’s just "), _c('i', [_vm._v("true.")])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But neither should we ignore it.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Many of us live with the assumption that whatever is in the way of a better life—and in the case before us, a better "), _c('i', [_vm._v("spiritual ")]), _vm._v("life—resides outside of us. When we consider why we are not growing spiritually or growing more in our love for God and neighbor—which sums up the whole spiritual journey as described by Jesus—we often assume it has to do with something external to us.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We change churches. We find new podcasts. We buy a new book (this one included). We search for some external thing that will give us what we’re looking for. A conference. A new method. New spiritual practices and workouts. The changes we often seek in order to bolster our spiritual life are primarily external. But the things that keep us bound up and stuck are not external to us. They are within us.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This is what all good spiritual guides have taught us. And it is within the tradition that gave us these guides that I offer this book. The things that bind us can only do so to the extent that they remain hidden to us. But once we see them clearly—those inner masters that rule us and rob us of our freedom—we can join Christ, who is already present doing the slow work of healing us.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This is not a self-help book. It’s an invitation to see the way the love of God is the only thing, in the end, that does the work of transformation.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Addressing the things that hinder our spiritual freedom—the shame, the patterns of personality, the habits that keep us stuck, and the stories we tell about ourselves and others—is becoming easier and more accessible as social scientists and psychologists continue to give us data.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "role": "doc-pagebreak",
      "title": "8"
    }
  }, [_vm._v("Tools and books for spiritual formation are now ubiquitous in the twenty-first-century Western church. Even in church communities where two decades ago any talk of spiritual formation, contemplation, and spiritual direction were met with great caution (“Aren’t these New Age practices?”), you can now find Enneagram workshops, classes on centering prayer, and even a cadre of pew-sitters who have discovered the "), _c('i', [_vm._v("Spiritual Exercises ")]), _vm._v("of Saint Ignatius of Loyola. Brené Brown’s war on shame is becoming household language,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-002",
      "id": "ap_ntf-002-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" and others are building on that work."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-003",
      "id": "ap_ntf-003-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Having a therapist, being in a twelve-step recovery program, or pursuing marriage counseling is no longer met with suspicion from the church. The church, it seems, is growing in her capacity to care for souls.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("way of life")]), _vm._v(" that I’m inviting you toward is to live in such a way that those unseen things will quite regularly rise to the surface. What is now hidden will be revealed. And the church and the Spirit will guide you toward your freedom, which is your inheritance in Christ.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("With all this talk about freedom, perhaps you are wondering how and why this book is also about "), _c('i', [_vm._v("constraint?")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("A Way of Life")]), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In the span of about a hundred years, in the middle of the desert of modern-day Turkey and the mountain region outside of Alexandria, Egypt, a peculiar "), _c('i', [_vm._v("way of life")]), _vm._v(" emerged in the late third and early fourth century as a countercultural movement. A man named Athanasius was doing important theological work on the heels of the Council of Nicaea, one of the most important church meetings of all time. He also wrote a “bestseller”—the "), _c('i', [_vm._v("Life of Anthony")]), _vm._v(", a biography of a peculiar man who spent most of a "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak",
      "title": "9"
    }
  }, [_vm._v("twenty-year span living alone in a desert. His quiet life of constraint catalyzed a generation of early Christian practice.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This biography of Anthony spread an understanding of this way of life, which was growing at a steady pace and would soon be codified, organized, and shared. The church had already been undergoing a dramatic (and perhaps unfortunate) shift with the conversion of the Roman Emperor Constantine, making Christianity a state-sponsored religion. But outside the seats of power and influence were an increasing number of men and women who quietly shaped the future of Christian spirituality and discipleship. This "), _c('i', [_vm._v("way of life")]), _vm._v(" captured the attention of Saint Augustine, Saint Basil of Caesarea, Saint Macrina the Younger, and to some extent Basil’s younger brother Gregory of Nyssa.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("These are the ones whose books and stories you might know. They wrote the historical record and crafted history with their very lives. But countless men and women who had no title or position, many of whom you may have never heard—Pachomius, Saint Scholastica, Evagrius—created Christian community and spiritual formation practices that made the lives of the men and women we read about, and their contribution to the church, possible.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This"), _c('i', [_vm._v(" way of life")]), _vm._v(" centered around practices of constraint"), _c('i', [_vm._v(".")]), _vm._v(" It marked out specific rhythms of prayer and work and study. It eventually gave birth to monasticism—men and women living in communities with a shared set of practices—and it became the primary model of intentional spiritual formation for most of the next thirteen hundred years.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As this "), _c('i', [_vm._v("way of life ")]), _vm._v("became institutionalized in those first few centuries, it would radically transform culture. It would inspire men like Benedict of Nursia, who founded the Benedictine "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "role": "doc-pagebreak",
      "title": "10"
    }
  }, [_vm._v("communities, which were refined by later generations, who planted Cistercian monasteries like the Abbey of Gethsemani, where Thomas Merton lived and wrote and reimagined what the life of a monk could become.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mother Teresa also followed in this tradition and way of life, founding her own religious order—the Missionaries of Charity—in 1950 with a singular focus on serving the poor in Calcutta, India.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Saint Francis of Assisi, Saint Ignatius of Loyola, Saint Teresa of Ávila, and Saint John of the Cross all lived and prayed and served the church tethered to a "), _c('i', [_vm._v("way of life")]), _vm._v(" rooted in constraint. More recently Thomas Keating, André Louf, and Frs. Richard Rohr, Ronald Rolheiser, and Basil Pennington have lived and prayed and served the church in this way of life. There are countless brothers and sisters who have kept this spiritual tradition alive, many living quietly enough to go unnoticed but faithful enough to be a ballast in the ship of the church since before our creeds were established.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There have always been men and women who have held and lived this wisdom of constraint, and they have been one of the most overlooked cultural forces in history. You have probably thought little about them. This book is an invitation to move your life toward their way of life"), _c('i', [_vm._v("—")]), _vm._v("a life of constraint. It is an invitation to the deep formation that is possible when a life of constraint is embraced in community.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A life with some constraints makes a life of freedom possible.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("A Rule of Life")]), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The pursuit of freedom through the practice of constraint is a well-worn path. What began in the desert with men like Saint Anthony living alone in caves morphed into men and women practicing the way of constraint together in community. Small "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "role": "doc-pagebreak",
      "title": "11"
    }
  }, [_vm._v("communities formed around shared practices, at first out of the simple need to survive. It turns out that being completely alone is much harder than people imagine. Simple practicalities of survival drew these men and women together into shared housing, shared rhythms of prayer and work, and shared resources. This allowed the pursuit of this way of life to flourish in ways that it could not when practiced alone.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sharing this way of life with others had a multiplying effect. There was more time for prayer when you were not the only one thinking about the food you would eat tomorrow. Within a few short decades the so-called ideal ascetic life of a holy man living in a cave was more or less abandoned. Community and shared common life were the future, even if shorter periods of cave and desert dwelling were permissible.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("From these new communities emerged a peculiar form of literature as the monastic “rule of life” took shape."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-004",
      "id": "ap_ntf-004-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" It turns out that it isn’t only the case where two or three are gathered together—“there the Lord is.” It turns out that where two or three are gathered together—there also is a great need to write some things down that those two or three can agree upon. Somebody needs to do the dishes.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("So already constraint begins its work because agreeing with two or three others on how you should live your life together is an excellent lesson in constraint. There can be no community without particular constraints. Marriage, for example, is the constraint of a certain kind of love to one other person; a family is constrained by both spoken and unspoken rules that govern a household; the people of God are constrained, as the apostle Paul notes, by the love of Christ ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=2+Cor+5%3A14&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("2 Cor 5:14")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Community requires constraint.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "role": "doc-pagebreak",
      "title": "12"
    }
  }, [_vm._v("By the time Saint Benedict came around in the late fifth century, there were several rule-of-life documents representing various approaches, all of which were trying to give shape to both individual and communal life. By the ninth century, more than twenty-five rules of life existed. Saint Benedict’s Rule became the most influential throughout monastic communities, even though most of it was borrowed and liberally modified from a rule known as the Rule of the Master. It was in use well before Benedict arrived on the scene. As Esther de Waal points out, Benedict")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("was happy to take what was good from the existing monastic heritage, to make it his own, and to colour it with his own personal experience. As he looked round he found various types of monastic life with their own traditions and achievements. There were some forms of life which allowed much scope for individual development and for the life of solitude; others stressed more the value of a corporate life in a settled community. He drew these different strands together."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-005",
      "id": "ap_ntf-005-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("Something Is Missing in Our Formational Practices")]), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In the preface to "), _c('i', [_vm._v("The Spirit of the Disciplines, ")]), _vm._v("Dallas Willard lays before us two tasks that are vital if Christianity is to be a guide for humanity:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("First, it must take the need for human transformation as seriously as do modern revolutionary movements. The modern negative critique of Christianity arose in the first place because the church was not faithful to its own message—it failed to take human transformation seriously as a real, practical issue to be dealt with in realistic terms.")]), _c('p', {
    staticClass: "txt_courant_justif last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "role": "doc-pagebreak",
      "title": "13"
    }
  }, [_vm._v("Second, it needs to clarify and exemplify realistic methods of human transformation. It must show how the ordinary individuals who make up the human race can become, through the grace of Christ, a love-filled, effective, and powerful community."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-006",
      "id": "ap_ntf-006-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I miss Dallas Willard.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He goes on to articulate his vision for the second task, masterfully painting the contours of the spiritual life and demonstrating how our body—that’s right, our"), _c('i', [_vm._v(" body")]), _vm._v("—is a “primary "), _c('i', [_vm._v("resource")]), _vm._v(" for the spiritual life.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-007",
      "id": "ap_ntf-007-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" He writes what has become a classic work on the spiritual disciplines in support of his central claim that we in fact "), _c('i', [_vm._v("can")]), _vm._v(" become like Christ by following him in his lifestyle, which includes “solitude and silence, prayer, simple and sacrificial living, intense study and meditation on God’s Word and God’s ways, and service to others.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-008",
      "id": "ap_ntf-008-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It would be hard to improve on Willard’s articulation of the spiritual disciplines. And when we combine Willard’s insights with Richard Foster’s "), _c('i', [_vm._v("Celebration of Discipline")]), _vm._v(", which was published a decade earlier, it seems we have what we need to begin practicing the spiritual disciplines in a way that leads to deeper formation and transformation. Those two books have done tremendous work in guiding people into a new way of living.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Yet nearly everyone who tries on a life of practicing the spiritual disciplines learns quickly that formational practices are difficult to stick to. Practicing forms of spiritual life that require discipline is really hard. We are often missing a key component that I think can make our practices stick. It’s also the primary component of the monastic tradition—the tradition that both Willard and Foster and many others are drawing from. It’s the monastic tradition that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "role": "doc-pagebreak",
      "title": "14"
    }
  }, [_vm._v("has kept this way of life and the practices of spiritual disciplines alive when, as Willard himself concedes, the practice of the disciplines became for all practical purposes lost to us in Western Christianity. I think we need to take up Willard’s first task. We “must take the need for human transformation as seriously as do modern revolutionary movements.”")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The problem with leaning into a life of "), _c('i', [_vm._v("constraint")]), _vm._v(", which is the primary way I will be talking about the spiritual disciplines, is that we almost exclusively have tried to do it alone. We have few living models for what it looks like to do it together. This is an unfortunate and unforeseen consequence of the Reformation, which systematically threw out the “baby” of the religious life of monks and nuns along with the “bathwater” that the Reformers wanted to throw out—however you want to describe that bathwater. What was lost in the Reformation (for those of us who are not Catholic or Orthodox) was the institution of monastic communities bearing witness to a communal way of life that centered on the practice of constraint"), _c('i', [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Willard and Foster, and others such as David Benner, Ruth Haley Barton, and Kathleen Norris, have drunk deeply from the life that the monastic tradition has brought us. They’ve gifted us with writing about the riches they themselves have gleaned in conversations with abbots and sisters at retreats in monasteries and convents. But the key component that has been left out in most of our attempts to lean into these practices is a commitment to doing so alongside others in a vulnerable way.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Call it spiritual companionship.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Call it spiritual friendship.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Call it monastic.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "role": "doc-pagebreak",
      "title": "15"
    }
  }, [_vm._v("But the spiritual disciplines were never meant to be primarily practiced alone. We are meant to share the joys and burdens of the practice of spiritual disciplines with others. The formation that comes from practicing constraint happens mostly when we practice alongside others.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This book is an invitation to practice constraint in community.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Over the past ten years, I have been slowly trying to reimagine the tradition that has carried the communal practice of constraint in monasteries and religious orders. I believe that monasticism and religious orders as institutions of the church will have a resurgence in the days ahead. The result of that reimagining work, and my own contribution to that hoped-for future, is the Order of the Common Life—an ecumenical religious order for the twenty-first century."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-009",
      "id": "ap_ntf-009-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Since the middle of the twentieth century there have been several men and women living in monastic communities or as part of a traditional Catholic religious order who have made it clear that, unless this tradition is reimagined and rearticulated, it will die. Thomas Merton spent much of his own monastic vocation thinking and writing about what is at the core of this tradition. Merton himself wondered how we might authentically carry it—reimagine it—for the sake of the church.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I’ve committed the rest of my life to the same question that Merton was asking: How do we authentically continue this tradition? We have invited men and women from around the world to consider and discern whether or not they have what has been traditionally referred to as a "), _c('i', [_vm._v("religious vocation")]), _vm._v(". We lead people through a multi-year discernment process around our own rule of life. Our primary "), _c('i', [_vm._v("charism")]), _vm._v(" (gift) that we offer the world is the work of helping people notice and nurture the work of God in their lives and in the lives of others. We believe that the most "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "role": "doc-pagebreak",
      "title": "16"
    }
  }, [_vm._v("important human experience is the experience of the love of God. You can explore more about our dispersed community and read our rule of life at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.orderofthecommonlife.org",
      "target": "_blank"
    }
  }, [_vm._v("www.orderofthecommonlife.org")]), _c('i', [_vm._v(".")])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The six commitments of constraint in the second half of this book are drawn from our last decade of trying to work this out with others. And, while these commitments alone do not constitute a rule of life, they offer an introduction to a way of life for you and your community, church, or family. If these practices resonate with you, I invite you to consider wading in a little deeper through our dispersed community of the Order of the Common Life.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("An Overview")]), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In this book, I offer three meditations, a practical overview, six practices of constraint meant to be done in community, and a very short invitation. I have just one hope for you: that you can begin a journey of finding freedom through the practice of constraint, sustained by the presence of others who are on the journey with you.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This book centers around the practice of constraint, but at the center of it all is the ability to see a greater degree of the love of God. Most of us are not actively looking for ways for our life to be constrained. When I first mentioned this project to a friend and got to the part about challenging people to take on some constraint, his honest response was “That sounds terrible.” I offer a vision of why we need constraint, and I hope that you will welcome more constraint than you ever thought possible.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Freedom is a theme that we’re all aware of, particularly for those living in America. And yet the freedom I’m advocating for is entirely different from the freedom we hear about in our cultural "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "role": "doc-pagebreak",
      "title": "17"
    }
  }, [_vm._v("context. The freedom that the best guides of the contemplative tradition talk about has little to do with getting what you want. In fact, it has more to do with not getting what you want than it has to do with almost anything else.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In parts two and three, I offer six practices of constraint. I could have chosen others, of course. These six shouldn’t necessarily have priority over other practices—with the exception of silence and solitude, which is foundational to any contemplative work. I don’t believe any real discipleship can happen apart from the practice of silence and solitude. It’s why these practices show up in nearly every book on spiritual disciplines. I’ll offer some basic guidance for practicing the practices, but I’m more interested in helping us understand "), _c('i', [_vm._v("why")]), _vm._v(" silence and solitude do so much heavy lifting in the contemplative and formational stream. We learn silence and solitude through practice. My goal is to help us desire the gift that they can bring.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("If you find yourself struggling to work through some of these constraints, you are in good company. I have a lot of hope for the church to lean in this direction, but it is a hope tempered by reality. I have been trying to live a way of life with some constraints at the center for nearly a decade. There has been a lot of ego and fear and a host of things that have needed to receive the healing love of God in my life as I have leaned into some of these practices. The way of life that I’m inviting you into is full of struggle. But the struggle is actually part of the work. We have rarely created spaces to talk about the struggle of these practices; I’m trying to change that.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Finally, this book is meant to be a guide for communities of formation, primarily as a resource in the local church, for ordinary people like you and me, living ordinary lives, learning how to love "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "role": "doc-pagebreak",
      "title": "18"
    }
  }, [_vm._v("through practicing together a way of life in community, sharing commitments to practices that will deepen our capacity to love one another.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As you work your way through this book in community, I hope what begins to surface is a vision for how this "), _c('i', [_vm._v("way of life")]), _vm._v(" might be lived together within your local church. I’ve created additional resources for you that can be accessed at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.jaredpatrickboyd.com",
      "target": "_blank"
    }
  }, [_vm._v("www.jaredpatrickboyd.com")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For now, I invite you to notice and nurture the work that God does in you while you read this book. Discuss it with others. Try on some practices. Keep a journal. Set aside time to pray.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But please do not read this book alone.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This book is meant to be discussed and its practices are meant to be practiced alongside others. Visit "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.orderofthecommonlife.org",
      "target": "_blank"
    }
  }, [_vm._v("www.orderofthecommonlife.org")]), _vm._v(" for guidance on how to form a conversation group around this book in your local church or join a group online. There will be plenty of opportunities to do this work together.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But don’t be a hermit in a cave.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 69
// module chunks = 0